import { Injectable } from '@angular/core';
import { Observable, of, Subscription, Subject, fromEvent, merge } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Session, AppSession } from '../objects/Session';
import { catchError, mapTo } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { TokenManager } from '../Globals';
import { Globals } from '../objects/Globals';
import {ToasterService, Toast, BodyOutputType} from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from './toaster-message.service';
import { BsModalService } from '../../../node_modules/ngx-bootstrap';
import { EnvService } from '../env.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true' })
};

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private session = new Subject<AppSession>();
  private loginUrl:string;
  private toasterService: ToasterService;
  private defaultId = '00000000-0000-0000-0000-000000000000';
  private isMobile = new Subject<boolean>();
  isMobileChanged$ = this.isMobile.asObservable();

  setDeviceInfo(isMobile: boolean){
    this.isMobile.next(isMobile);
  }

  loggedIn$ = this.session.asObservable();
  online$: Observable<boolean>;

  login(loginCredentials: any):Observable<AppSession>{
    var httpOption = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true'})
    };
    return this.http.post<AppSession>(`${this.loginUrl}StartSession`, loginCredentials, httpOption).pipe(
      catchError(this.handleError('login', null))
    );
  }

  proceed(holdId:string, isProceed:boolean, param: any){
    var path = this.loginUrl +"ProceedLogin/"+holdId+"/"+isProceed;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true'})
    };
    return this.http.post<AppSession>(`${path}`, param, httpOptions);
  }

  getSessionKey():Observable<string>{
    var path = this.loginUrl +"GenerateSessionContinueKey";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  continueSession(username:string, password:string, sessionId:string):Observable<AppSession>{
    var self = this;
    return this.http.post<AppSession>(`${this.loginUrl}ContinueSession/${username}/${password}/${sessionId}`, "", httpOptions).pipe(
      catchError(this.handleError('login', null))
    );
  }

  getSession(sessionId:string):Observable<string>{
    var self = this;
    return this.http.get<string>(`${this.loginUrl}GetSession/${sessionId}`, httpOptions)
  }

  setSession(session:AppSession):void{
    this.session.next(session);
  }

  getHomePage():Observable<string>{
    var path = this.loginUrl +"GetHomePage";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  goHome():Observable<string>{
    var path = this.loginUrl +"GoHome";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  resendVerificationEmail(param:any):Observable<string>{
    var path = this.loginUrl +"ResendVerificationEmail";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  forgotLoginDetails(param:any):Observable<string>{
    var path = this.loginUrl +"ForgotLoginDetails";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  resetPassword(param:any):Observable<string>{
    var path = this.loginUrl +"ResetPassword";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  validatePassword(param:any):Observable<string>{
    var path = this.loginUrl +"ValidatePassword";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId, "Session": this.defaultId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }
  
  constructor(private http:HttpClient, private router: Router, private tokenManager: TokenManager, private bsModalService:BsModalService, private globals: Globals, 
    toasterService: ToasterService, private toasterMessageService: ToasterMessageService, private env: EnvService) {
      this.loginUrl = this.env.servicePath;
      this.toasterService = toasterService;
      this.online$ = merge(
        of(navigator.onLine),
        fromEvent(window, 'online').pipe(mapTo(true)),
        fromEvent(window, 'offline').pipe(mapTo(false))
      );
  }

  private log(message:string){
    console.log(`LoginService: ${message}`);
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
   
      // TODO: send the error to remote logging infrastructure
      console.log(error); // log to console instead
      this.setSession(null);
      if (error.status == 400){
        this.popToast("Connection is lost", "There seems to be a problem connecting to the server, please contact system administrator accordingly", "warning");
        setTimeout(()=>{ 
          //this.clear();
          //this.router.navigate(['/login']); 
        }, 4000)
      }
      else{
        this.popToast("Error", "Unable to connect to the service", "error");
        //this.clear();
        //this.router.navigate(['/login']);
      }
      
      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);
   
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  clear(){
    this.globals.Session = null;
    this.session.next();
    this.bsModalService.hide(1);
    document.body.classList.remove('modal-open');
    this.tokenManager.clear();
    this.toasterMessageService.clearToaster();
  }

  popToast(title: string, body: string, type:string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.toasterMessageService.pushToaster(toaster);
      }
    };
    var toasterObj = this.toasterMessageService.getToaster()
    if (toasterObj.length > 0){
      if(toasterObj.slice(-1).pop().title != 'Connection is lost'){
        this.toasterService.pop(toast);
      }
    }
    else{
      this.toasterService.pop(toast);
    }
  }
}
